import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import type { FamilyPlan } from 'reactApp/modules/family/family.types';

export class GetFamilyPlanAPICall extends APICallV4<FamilyPlan> {
    _method = 'family/plan';
    _type: Method = 'get';
    _retriesCount = 0;
}
